module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/locations.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/locations.jpg
// module id = 33
// module chunks = 0